import { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { useAssetManagerLeftButtons } from '../../../consts';
import { ManagePageType } from '../../../types';
import { DefaultLayout } from '../DefaultLayout';
import { SubLayout, SubLayoutProps } from './SubLayout';
export const StoreManageLayout = (props: StoreManageLayoutProps) => {
  const {
    query
  } = useRouter();
  const currentPage = query.type as ManagePageType;
  const leftButtons = useAssetManagerLeftButtons();
  return <DefaultLayout data-sentry-element="DefaultLayout" data-sentry-component="StoreManageLayout" data-sentry-source-file="StoreManageLayout.tsx">
      <SubLayout currentPage={currentPage} leftButtons={leftButtons} {...props} data-sentry-element="SubLayout" data-sentry-source-file="StoreManageLayout.tsx" />
    </DefaultLayout>;
};
export const getStoreManageLayout = (page: ReactElement, storeManageLayoutProps?: StoreManageLayoutProps) => <StoreManageLayout {...storeManageLayoutProps} data-sentry-element="StoreManageLayout" data-sentry-component="getStoreManageLayout" data-sentry-source-file="StoreManageLayout.tsx">{page}</StoreManageLayout>;
type StoreManageLayoutProps = Partial<Omit<SubLayoutProps, 'children'>>;